'use client'
import { useEffect } from 'react'

// GTM loads on the visitor's first interaction (or once the page has sat idle
// for a few seconds) instead of being preloaded in <head>, where its script
// competed with the hero image for LCP and ran during the first tap (INP).
// The idle fallback keeps pageviews from visitors who never interact.
//
// Listeners go on `document` in the CAPTURE phase: this site scrolls inside the
// `.light-theme` wrapper, never the window, and scroll events don't bubble.
const EVENTS = ['pointerdown', 'keydown', 'touchstart', 'scroll']
const IDLE_FALLBACK_MS = 5000
const OPTS = { capture: true, passive: true }

export default function GtmOnInteraction({ gtmId }) {
    useEffect(() => {
        if (!gtmId) return
        if (document.querySelector('script[src*="googletagmanager.com/gtm.js"]')) return

        let timer
        const cleanup = () => {
            EVENTS.forEach((e) => document.removeEventListener(e, load, OPTS))
            clearTimeout(timer)
        }
        function load() {
            cleanup()
            if (document.querySelector('script[src*="googletagmanager.com/gtm.js"]')) return
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })
            const s = document.createElement('script')
            s.async = true
            s.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`
            document.head.appendChild(s)
        }

        EVENTS.forEach((e) => document.addEventListener(e, load, OPTS))
        timer = setTimeout(load, IDLE_FALLBACK_MS)
        return cleanup
    }, [gtmId])

    return null
}
